<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>I.A Voice Eleven Labs</h3>
      </div>
      <div class="box-content">
        <p>
          Configure os dados de acesso da api de whats da Eleven Labs.
        </p>
        <a href="https://elevenlabs.io/docs/product/introduction" target="_blank">https://elevenlabs.io/docs/product/introduction</a>
        <form>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>API URL</label>
              <input class="input" type="text" v-model="newElevenLabs.apiUrl" />
            </div>
            <div class="item flex-1">
              <label>API TOKEN</label>
              <input class="input" type="text" v-model="newElevenLabs.apiToken" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Voice Id</label>
              <input class="input" type="text" v-model="newElevenLabs.voiceId" />
            </div>
            <div class="item flex-1">
              <label>Model Id</label>
              <input class="input" type="text" v-model="newElevenLabs.modelId" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Voice settings</label>
              <input class="input" type="text" v-model="newElevenLabs.voiceConfig" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="">
              <div class="button primary" @click="saveSMTP()">
                Salvar
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
} from "@/services/integration";


export default {
  name: "elevenlabs",
  data() {
    return {
      newElevenLabs: {
        apiUrl: '',
        apiToken: '',
        voiceId: '',
        bearerToken: '',
        modelId: '',
        voiceConfig: ''
      }
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    saveSMTP() {
      let data = {
        apiUrl: this.newElevenLabs.apiUrl,
        apiToken: this.newElevenLabs.apiToken,
        voiceId: this.newElevenLabs.voiceId,
        modelId: this.newElevenLabs.modelId,
        voiceConfig: this.newElevenLabs.voiceConfig,
      };

      if (!data.apiUrl || !data.apiToken) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar a integração!",
        });
      }

      let params = {
        elevenlabs: data
      };

      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Integração salva com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar integração",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.newElevenLabs = result.elevenlabs;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },

  },
};
</script>
